import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheck
} from '@fortawesome/free-solid-svg-icons'


class Host extends React.Component {

  shouldComponentUpdate() {
    return false
  }

  constructor(props) {
    super(props)
    this.state = {
      height: 0,
      width: 0
    }
  }

  updateDimensions = () => {
    if (this.state.height !== window.innerHeight) {
      this.setState({ height: window.innerHeight })
    }
    if (this.state.width !== window.innerWidth) {
      this.setState({ width: window.innerWidth })
    }
  }


  componentDidMount() {
    this.setState({ height: window.innerHeight, width: window.innerWidth })
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  render() {

    const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 80px 0 50px 0;
            .heading {
                width: 100%;            
            @media (max-width: 767px) {
                padding: 10px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
        `

    const ServiceRow = styled(Row)`
            
        `
    const ServiceRow1 = styled(Row)`
            margin-top: 50px;
        `

    const TecText = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #555555;            
        `

    const ResponsiveTable = styled.table`
          width: 100%;
          margin-bottom: 1.5em;
          border-spacing: 0;
          
          thead {
            // Accessibly hide <thead> on narrow viewports
            position: absolute;
            clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
            padding: 0;
            border: 0;
            height: 1px; 
            width: 1px; 
            overflow: hidden;
            
            @media (min-width: 48em) {
              // Unhide <thead> on wide viewports
              position: relative;
              clip: auto;
              height: auto;
              width: auto;
              overflow: auto;
            }
            
            th {
              background-color: rgba(104,104,104,1);              
              font-weight: normal;
              text-align: left;
              color: white;
              
              &:first-of-type {
                text-align: left; 
              }
            }
          }
          
          // Set these items to display: block for narrow viewports
          tbody,
          tr,
          th,
          td {
            display: block;
            padding: 0;
            text-align: left;
            white-space: normal;
          }
          
          tr {   
            @media (min-width: 48em) {
              // Undo display: block 
              display: table-row; 
            }
          }
          
          th,
          td {
            padding: .5em;
            vertical-align: middle;
            
            @media (min-width: 30em) {
              padding: .75em .5em; 
            }
            
            @media (min-width: 48em) {
              // Undo display: block 
              display: table-cell;
              padding: .5em;
            }
            
            @media (min-width: 62em) {
              padding: .75em .5em; 
            }
            
            @media (min-width: 75em) {
              padding: .75em; 
            }
          }
          
          caption {
            margin-bottom: 1em;
            font-size: 1em;
            font-weight: bold;
            text-align: center;
            
            @media (min-width: 48em) {
              font-size: 1.5em;
            }
          }
          
          tfoot {
            font-size: .8em;
            font-style: italic;
            
            @media (min-width: 62em) {
              font-size: .9em;
            }
          }
          
          tbody {
            @media (min-width: 48em) {
              // Undo display: block 
              display: table-row-group; 
            }
            
            tr {
              margin-bottom: 1em;
              
              @media (min-width: 48em) {
                // Undo display: block 
                display: table-row;
                border-width: 1px;
              }
              
              &:last-of-type {
                margin-bottom: 0; 
              }
              
              &:nth-of-type(even) {
                @media (min-width: 48em) {
                  background-color: rgba(0,0,0,.12);
                }
              }
            }
            
            th[scope="row"] {
              background-color: rgba(38,137,13,1);
              color: white;              
              
              @media (min-width: 48em) {
                background-color: transparent;
                color: rgba(0,0,0.87);
                text-align: left;
              }
            }
            
            td {
              text-align: right;
              
              @media (min-width: 48em) {                
                text-align: left; 
              }              
              
            }
            
            td[data-type=currency] {
              text-align: right; 
            }
            
            td[data-tooltip-content]:before {
              content: attr(data-tooltip-content);
              float: left;
              font-size: .8em;
              color: rgba(0,0,0,.54);
              
              @media (min-width: 30em) {
                font-size: .9em; 
              }
              
              @media (min-width: 48em) {
                // Don’t show data-tooltip-content labels 
                content: none; 
              }
            } 
          }          
          `

    const Badge = styled.span`
          display:inline-block;
          background-color: #80c800 !important;
          padding:.25em .4em;
          font-size:75%;
          font-weight:700;
          line-height:1;
          text-align:center;
          white-space:nowrap;
          vertical-align:baseline;
          border-radius:.10rem;
          transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
          `

    const Badge1 = styled.span`
          display:inline-block;
          color: white;
          background-color: #808080 !important;
          padding:.25em .4em;
          font-size:75%;
          font-weight:700;
          line-height:1;
          text-align:center;
          white-space:nowrap;
          vertical-align:baseline;
          border-radius:.10rem;
          transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
          `

    const Color1 = styled.span`            
          font-weight: bold;          
        `

    const Color2 = styled.span`            
          font-weight: bold;
          color: #40a832;            
        `

    const Color3 = styled.span`          
          color: #40a832;
          font-family: "Teko", sans-serif;            
        `
    const Heading2 = styled.h2`
            transform: translate(0, -100px);            
            transition: 1s;
            margin-top: 100px;            
            font-size: 50px;
            line-height: 50px;
            font-family: "Teko", sans-serif;
            font-weight: bold;
            color: #000;
            text-align: center;
        `


    return (
      <Section>
        <Container>
          <Heading2>Especificaciones técnicas del <Color3>Hosting</Color3></Heading2>
          <ServiceRow>
            <Col md={12}>
              <TecText>
                Utilizamos lo último en tecnología SSD, unidades SSD NVMe. Esto da como resultado
                un SEO mejorado, velocidades de carga de sitios web de comercio electrónico y WordPress
                incomparables y una mejor experiencia de navegación del usuario final.
                Poseemos y operamos todo nuestro hardware y brindamos soporte interno rápido y de calidad.
              </TecText>
              <TecText>
                Optimizado para negocios en Pereira, Bogotá, Bucaramanga, Dosquebradas, Cali, Medellín, Barranquilla, Eje cafetero y en general para todo Colombia.
              </TecText>
            </Col>

          </ServiceRow>
          <ServiceRow1>
            <Col md={12}>

              <ResponsiveTable>
                <thead>
                  <tr>
                    <th scope="col">Software <Badge>Plus</Badge></th>
                    <th scope="col">Bases de Datos</th>
                    <th scope="col">Software adicional</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <td colspan="7">Fuente: VASCO Solutions: Datos tomados al 01 de mayo de 2025.</td>
                  </tr>
                </tfoot>
                <tbody>
                  <tr>
                    <th scope="row" data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Administrador MultiPHP - El administrador del sistema configura la versión predeterminada del sistema PHP."><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> PHP 5.1/5.2/5.3/5.4/5.6/7.0/7.1<br></br>/7.2/7.3/7.4/8.0/8.1/8.2/8.3/8.4</th>

                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Bases de Datos"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> MySQL 10.5.26-MariaDB</td>
                    <td data-tooltip-content="Software adicional" data-tip="Malware Scanner y Firewall."><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> <Color1>Imunify 360 8.4.3-1</Color1></td>

                  </tr>
                  <tr>
                    <th scope="row"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> Perl 5.16.3</th>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Bases de Datos"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> phpMyAdmin 5.2.1</td>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Software adicional"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> Zend Optimizer</td>

                  </tr>
                  <tr>
                    <th scope="row"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> LiteSpeed Web Cache</th>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Bases de Datos"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> MySQL remoto</td>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Software adicional"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> Zend Guard Loader</td>

                  </tr>
                  <tr>
                    <th scope="row"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> Apache 2.4.51</th>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Bases de Datos"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> PostgreSQL 9.2.24</td>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Software adicional"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> ionCube Loader</td>

                  </tr>
                  <tr>
                    <th scope="row"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> Pear</th>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Bases de Datos"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> phpPgAdmin 7.13.0</td>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Software adicional"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> Zend Engine</td>

                  </tr>
                  <tr>
                    <th scope="row"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> LiteSpeed + LSCache</th>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Todos los planes"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> SubDominios ∞</td>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Todos los planes"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> Migración GRATIS</td>

                  </tr>
                  <tr>
                    <th scope="row"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> Backups remotos 7 días</th>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Todos los planes"><Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2> 1 Click Apps (Softaculous)</td>
                    <td data-tooltip-id="tech-hosting-tooltips" data-tooltip-content="Todos los planes"><Badge1> Premium </Badge1> 24/7 Ticket de soporte</td>

                  </tr>
                </tbody>
              </ResponsiveTable>
              <ReactTooltip id="tech-hosting-tooltips" place="top" type="dark" effect="float" />

            </Col>
          </ServiceRow1>
        </Container>
      </Section>
    )
  }

}

export default Host;